/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Forgot_PasswordInputs */

const en_common_sign_forgot_password = /** @type {(inputs: Common_Sign_Forgot_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forgot your password?`)
};

/**
* | output |
* | --- |
* | "Forgot your password?" |
*
* @param {Common_Sign_Forgot_PasswordInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_sign_forgot_password = /** @type {((inputs?: Common_Sign_Forgot_PasswordInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Forgot_PasswordInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_sign_forgot_password(inputs)
});
export { common_sign_forgot_password as "common.sign.forgot_password" }